import { useAssistant } from 'ai/react'
import { useAIContext } from 'containers/AI/context/AIProvider'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'services/slices/auth'
import styled from 'styled-components'
import { ChatEmpty } from './ChatEmpty'
import { ChatLoading } from './ChatLoading'
import { ChatMessage, ChatMessageList, ChatMessageScrollWrapper } from './ChatMessage'
import { InputArea } from './InputArea'

export const Chat: React.FC = () => {
  const { data } = useAIContext()
  const user = useSelector(selectCurrentUser)
  const { assistantId } = useAIContext()

  const { handleInputChange, input, messages, submitMessage, status, threadId } = useAssistant({
    api: window.envVariables.REACT_APP_AI_URL + '/v1/assistant',
    body: {
      userId: user?.user_id,
      clientId: user?.as_client_id,
      additionalData: JSON.stringify(data),
      assistantId,
      // model: 'gpt-4',
    },
  })

  return (
    <ChatWrapper>
      <ChatMessageScrollWrapper>
        <ChatMessageList isEmpty={messages.length === 0}>
          {messages.length === 0 && <ChatEmpty />}
          {messages.map((message, index) => (
            <ChatMessage key={index} message={message} />
          ))}
          {status === 'in_progress' && <ChatLoading />}
        </ChatMessageList>
      </ChatMessageScrollWrapper>

      <InputArea
        threadId={threadId}
        input={input}
        handleInputChange={handleInputChange}
        submitMessage={submitMessage}
      />
    </ChatWrapper>
  )
}

const ChatWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  button {
    flex-shrink: 0;
  }
`
